package chat.amp.tim

import de.connect2x.trixnity.messenger.extensions.tim.TIMSpec

enum class Flavor { PROD, REF, DEV }

interface CommonBuildConfig {
    val version: String
    val flavor: Flavor
    val spec: TIMSpec
    val appName: String
    val appId: String
    val licenses: String
}

@Suppress("NO_ACTUAL_FOR_EXPECT") // This links to sources generated on demand
expect val BuildConfig: CommonBuildConfig
